import styled from 'styled-components';

const ShopThisStoreCategoryGrid = styled.div`
  margin: 15px;
  display: flex;

  @media (min-width: 320px) and (max-width: 480px) {
    margin: 0px;
  }
`;

const ShopThisStoreCategoryRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

const ShopThisStoreCategoryCol = styled.div`
  flex: ${(props) => props.size};
  flex-direction: column;
  flex-basis: 100%;
`;

const SearchStoreCategoryWrapper = styled.div`
  .categories-l1-row-desktop {
    background-color: #f4f4f4;
    border-radius: 16px;
    height: 175px;
    z-index: 0;
    margin-top: -6px;

    @media (min-width: 1441px) {
      height: 128px;
    }

    @media (min-width: 1201px) {
      height: 128px;
    }

    @media (min-width: 1025px) and (max-width: 1200px) {
      height: 128px;
    }

    @media (min-width: 769px) and (max-width: 1024px) {
      height: 128px;
    }

    @media (min-width: 481px) and (max-width: 768px) {
      height: 100px;
    }

    @media (min-width: 320px) and (max-width: 480px) {
      height: 66px;
      border-radius: 0px;
      width: calc(100% - 0px);
      margin-bottom: 46px;
    }
  }

  .arrow-button {
    margin-top: auto;
    margin-bottom: auto;
    background-color: transparent;
    border: none;
    cursor: pointer;

    :focus,
    :hover {
      background-color: transparent;
      border: none;
      -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    }

    @media (min-width: 320px) and (max-width: 480px) {
      display: none;
    }

    @media (min-width: 769px) and (max-width: 1024px) {
      display: none;
    }

    @media (min-width: 481px) and (max-width: 768px) {
      display: none;
    }
  }

  .button-disabled {
    cursor: default;
  }

  .arrow {
    border: solid black;
    border-width: 0 1px 1px 0;
    display: inline-block;
    padding: 8px;
  }

  .right {
    transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
  }

  .left {
    transform: rotate(135deg);
    -webkit-transform: rotate(135deg);
  }

  .categories-l2-row-desktop {
    background-color: #dedede;
    border-radius: 16px;
    margin: -60px auto 10px auto;

    @media (min-width: 1201px) {
      height: 110px;
      margin: -50px auto 10px auto;
      width: calc(100%);
    }

    @media (min-width: 1025px) and (max-width: 1200px) {
      height: 110px;
      margin: -50px auto 10px auto;
      width: calc(100%);
    }

    @media (min-width: 769px) and (max-width: 1024px) {
      margin: -50px auto 10px auto;
      height: 110px;
      width: calc(100%);
    }

    @media (min-width: 481px) and (max-width: 768px) {
      height: 100px;
      width: calc(100%);
    }

    @media (min-width: 320px) and (max-width: 480px) {
      height: 66px;
      border-radius: 0px;
      width: calc(100%);
    }
  }

  .categories-l1-button-wrapper {
    margin-top: auto;
    margin-bottom: auto;
    overflow-x: scroll;
    white-space: nowrap;
    -ms-overflow-style: none;
    scrollbar-width: none;

    ::-webkit-scrollbar {
      display: none;
      width: 0;
    }
  }

  .categories-l2-button-wrapper {
    margin: 48px auto auto auto;
    overflow-x: scroll;
    white-space: nowrap;
    -ms-overflow-style: none;
    scrollbar-width: none;

    ::-webkit-scrollbar {
      display: none;
    }

    @media (min-width: 1201px) {
      margin: 48px auto auto auto;
    }

    @media (min-width: 1025px) and (max-width: 1200px) {
      margin: 48px auto auto auto;
    }

    @media (min-width: 769px) and (max-width: 1024px) {
      margin: 48px auto auto auto;
    }

    @media (min-width: 481px) and (max-width: 768px) {
      margin: 50px auto auto auto;
    }

    @media (min-width: 320px) and (max-width: 480px) {
      margin: 20px auto auto auto;
    }
  }

  .categories-button {
    text-transform: none;
    font-weight: 400;
    font-family: Nunito;
    border-color: #9b9b9b;
    border-style: solid;
    border-width: 1px;
    font-size: 14px;
    border-radius: 6px;
    height: 46px;
    margin: 0 18px 0 18px;

    @media (min-width: 481px) and (max-width: 768px) {
      height: 30px;
      font-size: 10px;
    }

    @media (min-width: 320px) and (max-width: 480px) {
      height: 25px;
      font-size: 8px;
    }
  }

  .button-active {
    font-weight: 700;
    border-color: #4b9fdd;
    font-family: Nunito;
    background-color: #ffffff;
    border-style: solid;
    border-width: 3px;
    font-size: 14px;
    border-radius: 6px;
    height: 50px;
    margin: 0 18px 0 18px;

    @media (min-width: 481px) and (max-width: 768px) {
      height: 30px;
      font-size: 10px;
    }

    @media (min-width: 320px) and (max-width: 480px) {
      height: 25px;
      font-size: 8px;
    }
  }
`;

export {
  ShopThisStoreCategoryGrid,
  ShopThisStoreCategoryRow,
  ShopThisStoreCategoryCol,
  SearchStoreCategoryWrapper,
};
